module.exports = __webpack_public_path__ + "static/media/4BIANCA_Official_MENU-20552.697e0145.jpg";